import { render, staticRenderFns } from "./lrDepartment.vue?vue&type=template&id=2bf7a327&"
import script from "./lrDepartment.vue?vue&type=script&lang=js&"
export * from "./lrDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports